module.exports = __webpack_public_path__ + "static/media/12.3bd1f752.jpg";